import React, { useState, useEffect } from 'react'

const AdminQuery = ({ userDetails }) => {
  const [complaints, setComplaints] = useState([]);
  const [error, setError] = useState(null);
    const [ticketStatus, setTicketStatus] = useState({});

  const userId = userDetails.id;

  useEffect(() => {
    if (userId) {
      // Fetch complaint history from the backend API using fetch
      fetch(`https://api.dectwincam.com/api/admin/get-complaints`)
        .then(async response => {
          // Log the response to check what is being returned
          const text = await response.text();
          console.log('Response Text:', text);  // Log the raw response for debugging

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}, response: ${text}`);
          }

          // Attempt to parse JSON
          return JSON.parse(text);
        })
        .then(data => {
          setComplaints(data.tickets || []);
        })
        .catch(error => {
          console.error('Error fetching complaints:', error);
          setError('Failed to fetch complaints');
        });
    } else {
      setError('No user ID found');
    }
  }, [userId]);  // Depend on userId to fetch complaints when it changes

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // For format "DD/MM/YYYY"
  };

    // Toggle the visibility of the delivery status form
    const toggleTicketStatus = (ticketId) => {
      setTicketStatus((prev) => ({
          ...prev,
          [ticketId]: !prev[ticketId], // Toggle delivery visibility for the clicked order
      }));
  };


      // Handle form submission to update delivery status
      const handleUpdateStatus = async (event, ticketId) => {
        event.preventDefault();
        const newStatus = event.target.status.value;
    
        try {
            const response = await fetch(`https://api.dectwincam.com/api/admin/complaints/${ticketId}/status`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ status: newStatus }), // Send the updated status
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to update order status');
            }
    
            const updatedOrder = await response.json();
    
            // Update the local state with the new status
            setComplaints((prevOrders) =>
                prevOrders.map((order) =>
                    order.orderId === updatedOrder.orderId ? { ...order, status: updatedOrder.status } : order
                )
            );
    
            // Close the delivery status form after update
            setTicketStatus((prev) => ({ ...prev, [ticketId]: false }));
            alert('Status Updated Successfully');
            window.location.reload();
    
        } catch (error) {
            console.error('Error updating order status:', error);
            setError(error.message);
        }
    };



  return (
    <>
      <section className='py-5 bg-light'>
        <div className='container'>

          <div className="d-flex justify-content-center">
            <hr className="shop-hr" />
            <h4 className="px-3 text-center text-nowrap">Complaints History</h4>
            <hr className="shop-hr" />
          </div>

          {error && <p className="text-danger">{error}</p>}
          {!error && complaints.length === 0 && <p>No complaints found.</p>}
          {!error && complaints.length > 0 && (
            <div className='order-list mt-5'>
              {complaints.map((complaint, index) => (
                <div className='order-item' key={index}>


                  <div className='row'>

                    <div className='col-lg-9 col-md-8 col-sm-6 col-12'>
                      <h5>Ticket ID #00{complaint.ticketId}</h5>
                      <p className='text-muted para-text'>Raised on: {formatDate(complaint.query_date)}<br />
                        Complaint Status: {complaint.status || 'NA'}</p>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12 text-end'>
                      {/* <button className='pay-btn' onClick={() => toggleDeliveryStatus(order.orderId)} >Update Delivery <i class="fa-solid fa-truck-fast"></i></button> */}

                      {!ticketStatus[complaint.ticketId] && (
                        <button
                          className='pay-btn'
                          onClick={() => toggleTicketStatus(complaint.ticketId)}
                        >
                          Update Ticket <i className="fa-solid fa-tags"></i>
                        </button>
                      )}

                      {ticketStatus[complaint.ticketId] && (
                        <>
                          <form className='bg-white' onSubmit={(event) => handleUpdateStatus(event, complaint.ticketId)}>
                            {/* You can add form fields here to update delivery status */}
                            <select className='login-input' name='status' defaultValue={complaint.status}>
                              <option className="login-input" value="" selected disabled>Status</option>
                              <option className="login-input" value="Refund Processed">Refund Processed</option>
                              <option className="login-input" value="Ticket Closed">Ticket Closed</option>
                              <option className="login-input" value="Out for Delivery">Out for Delivery</option>
                            </select>

                            <button type="submit" className='pay-btn'>Update Status</button>
                          </form>
                        </>
                      )}
                    </div>
                    {/* right section ends */}

                  </div>
                  {/* row ends */}


                  <h6 className='mt-4'>Complaint Details</h6>
                  <p className='text-muted para-text text-capitalize'>Customer Name: {complaint.clientName}<br />
                    Order No: #00{complaint.order_id}<br />
                    Query: {complaint.query}<br />
                    Description: {complaint.description}</p>
                </div>
              ))}
            </div>
          )}

        </div>
      </section>
    </>
  )
}

export default AdminQuery
